export const radioButtonStyles = theme => ({
  '& .MuiFormControlLabel-label': {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  '& label': {
    marginRight: theme.spacing(3),
    width: '100%',
  },
  borderRadius: 24,
  marginTop: theme.spacing(1),
  paddingLeft: theme.spacing(2),
});

export const radioGroupStyles = theme => ({
  marginBottom: theme.spacing(1),
  marginTop: theme.spacing(1),
  width: '100%',
});

export const withVerticalMarginStyles = theme => ({
  margin: `${theme.spacing(2)} 0`,
});
